module.exports = __webpack_public_path__ + "img/color5.7c12a718.jpg";